/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import imageFamilyLaw from "../../assets/img/products/Illustration_Familienrecht.svg";
import imageFamilyLawDark from "../../assets/img/products/Illustration_Familienrecht_dark.svg";
import imageEmploymentLaw from "../../assets/img/products/Illustration_Arbeitsrecht.svg";
import imageEmploymentLawDark from "../../assets/img/products/Illustration_Arbeitsrecht_dark.svg";
import imageTrafficLaw from "../../assets/img/products/Illustration_Verkehrsrecht.svg";
import imageTrafficLawDark from "../../assets/img/products/Illustration_Verkehrsrecht_dark.svg";
import imageContractLaw from "../../assets/img/products/Illustration_Vertragsrecht.svg";
import imageContractLawDark from "../../assets/img/products/Illustration_Vertragsrecht_dark.svg";
import imageTenancyLaw from "../../assets/img/products/Illustration_Mietrecht.svg";
import imageTenancyLawDark from "../../assets/img/products/Illustration_Mietrecht_dark.svg";
import ThemedIllustration from "../ThemedIconSwitch/ThemedIllustration";

const linkedCardsHomePage = [
  {
    icon: <ThemedIllustration lightIllustration={imageFamilyLaw} darkIllustration={imageFamilyLawDark} />,
    heading: "Familienrecht",
    subHeading: "Alle Rechtsangelegenheiten rund um das Thema Familie.",
    link: "/familienrecht",
  },
  {
    icon: <ThemedIllustration lightIllustration={imageEmploymentLaw} darkIllustration={imageEmploymentLawDark} />,
    heading: "Arbeitsrecht",
    subHeading: "Probleme mit dem Arbeitgeber? Wir können helfen.",
    link: "/arbeitsrecht",
  },
  {
    icon: <ThemedIllustration lightIllustration={imageTrafficLaw} darkIllustration={imageTrafficLawDark} />,
    heading: "Verkehrsrecht",
    subHeading: "Wir sind bei Verkehrsunfällen und Bußgeldern für Sie da.", //"Wir bewahren Sie vor Bußgeldern und Führerscheinverlust.",
    link: "/verkehrsrecht",
  },
  {
    icon: <ThemedIllustration lightIllustration={imageContractLaw} darkIllustration={imageContractLawDark} />,
    heading: "Vertragsrecht",
    subHeading: "Wir setzen uns für Ihre Probleme mit allen Arten von Verträgen ein.",
    link: "/vertragsrecht",
  },
  {
    icon: <ThemedIllustration lightIllustration={imageTenancyLaw} darkIllustration={imageTenancyLawDark} />,
    heading: "Mietrecht",
    subHeading: "Unterstützung bei Rechtsstreitigkeiten mit Ihrem Vermieter.",
    link: "/mietrecht",
  },
];

export default linkedCardsHomePage;
